import { FilteredCarListSortBy } from '@/modules/Search/types'

export const CAR_TYPE_OPTIONS = [
  'search.carTypeOptions.compact',
  'search.carTypeOptions.economy',
  'search.carTypeOptions.electric',
  'search.carTypeOptions.intermediate/mid-size',
  'search.carTypeOptions.standard',
  'search.carTypeOptions.full-size',
  'search.carTypeOptions.premium',
  'search.carTypeOptions.luxury',
  'search.carTypeOptions.suv',
  'search.carTypeOptions.convertible',
  'search.carTypeOptions.minivan',
  'search.carTypeOptions.pickup-truck',
  'search.carTypeOptions.hybrid',
]

export const CAR_SORT_OPTIONS: { key: string; value: string }[] = [
  {
    key: FilteredCarListSortBy.CarType,
    value: 'search.carSortOptions.carType',
  },
  {
    key: FilteredCarListSortBy.Price,
    value: 'search.carSortOptions.price',
  },
  {
    key: FilteredCarListSortBy.Capacity,
    value: 'search.carSortOptions.capacity',
  },
]
